module.exports = __webpack_public_path__ + "img/com.codeway.chatappweb.37a6664d.png";